import { AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { API } from '../../api';
import { addLoading, removeError, removeLoading } from './index';
import types from '../types';

export default function getCommonPictureStorage(
  id: string
): ThunkAction<Promise<void>, StoreRoot, unknown, AnyAction> {
  return async (dispatch) => {
    const entry = 'getCommonPictureStorage';

    dispatch(removeError(entry));
    dispatch(addLoading(entry));

    return API.restaurantApi
      .getCommonPictureStorages(id)
      .then((res: any) => {
        dispatch({
          type: types.SET_COMMON_PICT_STORAGE,
          payload: res.storage,
        });
      })
      .catch((err) => console.log('Error is', err.message))
      .finally(() => dispatch(removeLoading(entry)));
  };
}
